import type { FC, ReactNode } from 'react'

interface JsonLdProps {
    data: Record<string, unknown> | Record<string, unknown>[]
}

export const JsonLd: FC<JsonLdProps> = ({ data }): ReactNode => {
    return (
        <script
            type='application/ld+json'
            dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
    )
}
